import { User, MapPin, Briefcase } from "lucide-react";
import type { ToolWidgetProps } from "./index";
import { ProfileCardActions } from "./profile-card-actions";

interface Address {
  postal_code?: string;
  locality?: string;
  formatted_address?: string;
  latitude?: number;
  longitude?: number;
  administrative_area_level_1?: string;
  country?: string;
}

interface Candidat {
  id: number;
  name: string;
  user_id?: number;
  project_contribution?: number;
  secteurs?: string[];
  parent_secteurs?: string[];
  project_surface_min?: number;
  project_surface_max?: number;
  experience?: string;
  franchise_interest?: boolean;
  address?: Address;
}

interface SearchCandidatsData {
  results: Candidat[];
  total: number;
}

function CandidatCard({ candidat }: { candidat: Candidat }) {
  return (
    <div className="flex flex-col gap-2 p-3 bg-white rounded-lg border border-slate-200 hover:border-slate-300 transition-colors relative">
      <ProfileCardActions
        profile={{
          type: "candidat",
          id: candidat.id,
          name: candidat.name,
          user_id: candidat.user_id,
        }}
      />
          <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center">
            <User className="w-5 h-5 text-slate-400" />
          </div>
          <div className="min-w-0">
            <div className="font-medium text-slate-800 truncate">
              {candidat.name}
            </div>
            {candidat.secteurs && candidat.secteurs.length > 0 && (
              <div className="text-xs text-slate-500 truncate">{candidat.secteurs.join(", ")}</div>
            )}
            <div className="flex flex-col gap-1 mt-2 text-xs text-slate-500">
              {candidat.experience && (
                <div className="flex items-center gap-1">
                  <Briefcase className="w-3 h-3" />
                  {candidat.experience}
                </div>
              )}
              {candidat.address?.locality && (
                <div className="flex items-center gap-1">
                  <MapPin className="w-3 h-3" />
                  {candidat.address.locality}
                </div>
              )}
            </div>
          </div>
    </div>
  );
}

export function SearchCandidatsWidget({
  data,
  count,
}: ToolWidgetProps<SearchCandidatsData>) {
  const { results = [] } = data || {};

  if (!results.length) {
    return (
      <div className="text-sm text-slate-500 italic">Aucun candidat trouvé</div>
    );
  }

  return (
    <div className="grid grid-cols-4 gap-3">
      {results.map((candidat) => (
        <CandidatCard key={candidat.id} candidat={candidat} />
      ))}
      {count && count > results.length && (
        <div className="col-span-4 text-xs text-slate-400 text-center pt-1">
          + {count - results.length} autres résultats
        </div>
      )}
    </div>
  );
}
